import Const from 'constants';
import {Factory as DraftKingsFactory} from './sites/draftkings/factory';
import {Factory as FanDuelFactory} from './sites/fanduel/factory';
import {Factory as YahooFactory} from './sites/yahoo/factory';

const classesMap = {
    [Const.SITE_DK]: DraftKingsFactory,
    [Const.SITE_FD]: FanDuelFactory,
    [Const.SITE_YAHOO]: YahooFactory,
};

export const Factory = {
    getComponent(sportConfig) {
        const siteName = sportConfig.getSite().toLowerCase();

        if (siteName in classesMap) {
            return classesMap[siteName].getComponent(sportConfig);
        }

        throw new Error(`Unsupported factory for "${siteName}".`);
    },
};
